import { List, Record } from 'immutable';
import moment from 'moment';
import uuid from 'uuid/v1';

export const OrderInfoRecord = new Record({
  o_id: '',
  oi_id: 'oi_id_0',
  sub_o_id: uuid(),
  extral_id: '',
  booking_date: moment().format('YYYY-MM-DD HH:mm:ss'),      // 预订日期 orders_information.booking_date
  departure_date: null,  // 出行日期 orders_information.departure_date
  service_date: '',      // 时段 orders_information.service_date
  pickup_place: '',      // 接送服务(接送地点) orders_information.pickup_place
  hotel: '',             // 酒店 orders_information.hotel
  product_name: '',      // 项目 orders_information.product_name
  num: 0,                // 数量 orders_information.num
  remark: '',            // orders_information.remark
  supplier_id: '',       // orders_information.supplier_id
  supplier: '',          // 不作数据库操作用
  supplier_suffix_id: '',// orders_information.supplier_suffix_id
  status: 'Z_1',         // 不作数据库操作用
  status_code: 'Z_1',    // 订单状态 orders_information.status
  refund_status: '',     // 退款-售后 orders.refund_status
  payment: '',           // 子订单实付金额 orders_information.payment
  commission: '',        // 佣金 orders_information.commission
  profit: '',            // 利润 orders_information.profit
  profit_margin: '',     // 利润率 orders_information.profit_margin
  commission_rate: 0,    // 佣金比率 orders_information.commission_rate
  web_settlement: '',    // 平台结算价 orders_information.web_settlement
  supplier_offer: '',    // 供应商报价 orders_information.supplier_offer
  supplier_tax: '',      // 供应商报价税额 orders_information.supplier_tax
  supplier_tax_point: '0',// 供应商报价税点 orders_information.supplier_tax_point
  unit_id: 0,            // 单位id
  punit: '',            // 单位
  unit: '',            // 单位
  // refound_reason: '',    // 退款原因 orders_information.refound_reason
  // saler_reason: '',      // 售后原因 orders_information.saler_reason
  destination: '',       // 目的地 orders_information.destination
  destination_name: '',  // 不作数据库操作用
  destination_paths_name: '', // 不作数据库操作用
  // unit_id: 0,            // 单位 orders_information.unit
  sku_code: '',          // 产品编码
  pp_id: 0,
  is_shipment: 0,        // 出单状态 orders_information.is_shipment
  gear_p: 1,             // 1档、2档
  price: {
    adult_cost_price: 0,
    child_cost_price: 0,
    diff_cost_price: 0,
  },
  is_supplier_offer_lock: 0,
  // is_platform_settlement: 0,
  is_supplier_settlement: 0,
  order_types: 2,        // 订单类型
  arrangement: 0,        // 0、未安排 1、已经安排 2、无法安排
  order_remarks: '',     // 订单备注

  transaction_amount: 0,
  settlement_price: 0,
  refund_fee: 0,
  replenish_fee: 0,
  package_order_id: 0,   // 装前后的订单oi_id
  is_hoard_ticket: 0,    // 0：非　1、囤票
  total_insurance: 0,       // 保险费 总价
  insurance_included: 0,    // 是否含保险

  extra_info: {},
  pick0: '',
  pick1: '',
});

export const OrdersRecord = new Record({
  o_id: '',
  oi_id: 'oi_id_0',
  ordersn: '',
  web_source: '',        // 不作数据库操作用
  pf_id: '',             // 平台 orders.pf_id
  shop_id: 0,            // 店铺id
  web_source_id: '',     // 不作数据库操作用
  saler: '',
  saler_id: 0,           // 平台导购员ID(销售员id), 0未分配 orders.saler_id
  operator: '',
  groups_no: '',         // 团号 orders.groups_no
  groups_id: 0,          // 团号关联id, 0未分配 orders.g_id
  groups_code: '',       // 不作数据库操作用
  groups_info: '',       // 不作数据库操作用
  operator_id: 0,        // 平台计调, 0未分配 orders.operator_id
  total_fee: 0,          // 成交价 orders.total_fee
  orderid: '',           // 团号 orders.orderid
  group_no: '',          // 团号	orders.group_no  废弃
  account_payable: '',   // 应付款 人民币成本 orders.account_payable
  wj: '',                // 微建 orders.wj
  account: '',           // 买家帐号 id/ orders.account
  name: '',              // 姓名 orders.name
  email: '',             // 电话/微信/邮箱 orders.email
  weixinid: '',          // 电话/微信/邮箱 orders.weixinid
  phone: '',             // 电话/微信/邮箱 orders.phone
  orders_info: new List([]),
  o: '',                 // 对应平台订单表
  web_remark: '',        // 网前备注 orders.web_remark
  remark: '',            // 备注 orders.remark
  web_buyer_message: '',
  seller_flag: 0,        // 卖家备注旗帜
  is_click_farm: 0,      // 刷单 1（刷单）/ 0 （正式单） orders.is_click_farm
  farm_cost: 0,          // 刷单费用
  is_ledger_report: 0,   // 0 未上报 / 1 已上报, 默认0
  is_packaged_products: 0, // 不作数据库操作用
  // ledger_report_date: '',// 上报时间
  exchange_rate: 1,      // 币种当前对人民币汇率
  currency_id: 1,        // 结算币种id
  currency_name: '人民币',     // 不作数据库操作用
  created_by_id: 0,      // 创建人ID
  changed_by_id: 0,      // 修订人ID
  refund_fee: 0,
  replenish_fee: 0,
  group_tags: '',
  is_online: 0,          // 线上、线下

  transaction_amount: 0,
  schedules: new List([]),
  traveller: new List([]),
  payment: new List([]),
});

export const ScheduleRecord = new Record({
  o_s_id: '',
  o_id: '',
  type: 0,
  title: '',
  content_json: {},
  // createtime: '',
  // updatetime: '',
  status: 0,
  del: 0,
});
export const TravellerRecord = new Record({
  ori_id: '',
  o_id: '',
  sex: 1,
  telphone: '',
  traveller_name: '',
  credentials_code: '',
  credentials_type: '',
});
export const BillTransactionRecord = new Record({
  obt_id: '',
  tid: '',
  o_id: '',
  oi_id: '',
  payment_no: '',
  pay_time: '',
  received_time: '',
  income: '',
  expense: '',
  trade_channels: '',
  biz_channels: '',
  biz_office: null,
  ie_type: '',
  remarks: '',
  is_replenish_order: '',
  is_received: '',
  balance_types: '',
  receipt_files: [],
  created_by: 0,
  sub_o_id: '',
});
